import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';

import { CustomerService } from 'src/app/core/services/customers.service';

@Component({
  selector: 'app-customer-quick-add-popup',
  templateUrl: './customer-quick-add-popup.component.html'
})
export class CustomerQuickAddPopupComponent {
  formData: FormGroup;
  submitted = false;
  isSaving = false;

  constructor(
    private formBuilder: FormBuilder,
    private customerService: CustomerService,
    public activeModal: NgbActiveModal
  ) {
    this.formData = this.formBuilder.group({
      name: [null, [Validators.required]],
      gstNo: [null, [Validators.pattern('^[0-9]{2}[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}[1-9A-Za-z]{1}Z[0-9A-Za-z]{1}$')]],
      panNo: [null, [Validators.pattern('^[A-Za-z]{5}[0-9]{4}[A-Za-z]$')]],
      tanNo: [null, [Validators.pattern('^[A-Za-z]{4}[0-9]{5}[A-Za-z]$')]]
    }, { updateOn: 'blur' });
  }

  onSubmit() {
    this.submitted = true;
    if (this.formData.invalid) {
      this.formData.markAllAsTouched();
      return;
    }

    const payload = {
      ...this.formData.value,
      customerType: null,
      contacts: [],
      addresses: [],
      isUser: false,
      user: null
    };

    this.isSaving = true;
    this.customerService.saveCustomerData(payload)
      .pipe(finalize(() => { this.isSaving = false; }))
      .subscribe(
        (res: any) => {
          if (res?.isError) {
            Swal.fire(res?.error || 'Unable to save customer', '', 'error');
            return;
          }
          const savedId = Number(res?.data?.id);
          if (Number.isFinite(savedId) && savedId > 0) {
            this.customerService.getById(savedId).subscribe(
              (detailRes: any) => {
                if (detailRes?.isError) {
                  Swal.fire('Customer saved but details could not be loaded', '', 'warning');
                  this.activeModal.close({ customer: res?.data || null });
                  return;
                }
                this.activeModal.close({ customer: detailRes?.data || res?.data || null });
              },
              () => this.activeModal.close({ customer: res?.data || null })
            );
            return;
          }
          this.activeModal.close({ customer: res?.data || null });
        },
        () => Swal.fire('Unable to save customer', '', 'error')
      );
  }
}
